export interface NewsBlock {
  type: "p" | "h" | "image";
  text?: string;
  url?: string;
  caption?: string;
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  source: string;
  category: string;
  content: NewsBlock[];
  relatedIds: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "n01",
    title: "2025 年春季新番前瞻：多部原创动画集中定档",
    summary:
      "随着春季档期临近，多家制作公司陆续公布新一季作品阵容，其中原创企划占比明显提升，题材覆盖科幻、治愈与青春日常。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20colorful%20spring%20season%20announcement%20board%20with%20several%20stylized%20film%20posters%20floating%2C%20cherry%20blossoms%20in%20the%20air%2C%20bright%20cheerful%20palette%2C%20cel-shaded%2C%20clean%20simple%20light%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-01&orientation=landscape",
    date: "2025-03-18",
    source: "58动漫编辑部",
    category: "行业动态",
    content: [
      {
        type: "p",
        text: "随着春季档期临近，各大制作公司陆续公布新一季的作品阵容。与往年相比，本季最大的变化在于原创企划的数量显著增加，多家工作室选择将资源投入到没有原作基础的原创动画中。",
      },
      { type: "h", text: "原创企划成为主流选择" },
      {
        type: "p",
        text: "从已公布的信息来看，本季共有超过二十部原创动画定档，题材覆盖科幻、治愈、历史与青春日常。业内人士认为，原创作品能够更自由地控制叙事节奏，也更容易形成独特的品牌辨识度。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20bright%20animation%20studio%20workspace%20with%20artists%20at%20drawing%20tables%20and%20colorful%20storyboards%20pinned%20on%20walls%2C%20warm%20daylight%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-02&orientation=landscape",
        caption: "新一季作品的美术设定正在密集打磨中",
      },
      { type: "h", text: "题材更加多元" },
      {
        type: "p",
        text: "除了传统的热血冒险与奇幻校园，本季还出现了以美食、海洋、时间旅行等为切入点的作品。观众的选择空间进一步扩大，也让春季档的竞争更加激烈。",
      },
      {
        type: "p",
        text: "需要说明的是，以上定档信息均以各制作方最终公告为准，58动漫将持续跟进并更新最新进度。",
      },
    ],
    relatedIds: ["n03", "n05"],
  },
  {
    id: "n02",
    title: "国产动画电影票房再创新高，原创题材成新宠",
    summary:
      "多部国产动画电影在近期档期表现亮眼，原创故事与传统文化结合的作品尤其受到观众欢迎，市场结构正悄然变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20packed%20cinema%20auditorium%20glowing%20with%20screen%20light%2C%20silhouettes%20of%20audience%20watching%20a%20fantasy%20scene%2C%20warm%20amber%20and%20red%20tones%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-02&orientation=landscape",
    date: "2025-03-12",
    source: "动漫产业周报",
    category: "行业动态",
    content: [
      {
        type: "p",
        text: "近期档期内，多部国产动画电影取得了超出预期的票房表现。其中，以原创故事为核心、并融入传统文化元素的作品尤其受到观众青睐。",
      },
      { type: "h", text: "原创内容撑起口碑" },
      {
        type: "p",
        text: "与改编自知名 IP 的作品相比，原创动画反而凭借新鲜的设定与完整的叙事收获了不错的口碑。多家片方表示，未来会继续加大对原创剧本的投入。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20modern%20press%20conference%20stage%20with%20large%20screens%20and%20warm%20spotlights%2C%20simple%20clean%20hall%2C%20cel-shaded%2C%20professional%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-05&orientation=landscape",
        caption: "多部新片在发布会上公布后续计划",
      },
      {
        type: "p",
        text: "业内分析认为，观众对国产动画的期待正在从“技术炫技”转向“讲好故事”，这对创作者而言既是机会也是挑战。",
      },
    ],
    relatedIds: ["n10", "n08"],
  },
  {
    id: "n03",
    title: "《龙语者学院》第二季正式官宣，制作阵容公开",
    summary:
      "官方在最新直播活动中宣布《龙语者学院》第二季制作决定，并公开了主要制作阵容与先导视觉图，预计明年与观众见面。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20grand%20fantasy%20magic%20academy%20tower%20with%20dragons%20circling%20in%20a%20twilight%20sky%20and%20glowing%20runes%2C%20cel-shaded%2C%20epic%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-03&orientation=landscape",
    date: "2025-03-06",
    source: "官方公告",
    category: "作品资讯",
    content: [
      {
        type: "p",
        text: "在近日举行的线上直播活动中，官方正式宣布《龙语者学院》将制作第二季，并同步放出了先导视觉图与主要制作阵容名单。",
      },
      { type: "h", text: "故事将进入全新阶段" },
      {
        type: "p",
        text: "据主创介绍，第二季将延续第一季结尾的悬念，把舞台从学院扩展到更广阔的大陆。主角言默与古龙·烬之间的关系也会迎来重要转折。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20lively%20anime%20convention%20hall%20with%20cosplayers%20and%20booths%20under%20warm%20lights%2C%20crowd%20of%20fans%2C%20cel-shaded%2C%20cheerful%20festive%20mood%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-01&orientation=landscape",
        caption: "官宣活动吸引大量粉丝在线观看",
      },
      {
        type: "p",
        text: "官方表示，动画预计于明年播出，更多情报将在后续活动中陆续公开。",
      },
    ],
    relatedIds: ["n08", "n01"],
  },
  {
    id: "n04",
    title: "夏日烟火主题展将开启三城巡展，限定周边同步发售",
    summary:
      "以青春夏日为主题的线下展览将在三座城市巡回举办，现场设有原画展区、互动装置与限定周边商店，营造沉浸式体验。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20summer%20festival%20exhibition%20entrance%20decorated%20with%20lanterns%20and%20fireworks%20motifs%2C%20warm%20evening%20glow%2C%20cel-shaded%2C%20festive%20joyful%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-04&orientation=landscape",
    date: "2025-02-27",
    source: "展会组委会",
    category: "活动公告",
    content: [
      {
        type: "p",
        text: "以青春夏日为主题的线下巡展将于近期启动，先后在三座城市举办。展览以“留住这个夏天”为概念，打造沉浸式的观展体验。",
      },
      { type: "h", text: "三大主题展区" },
      {
        type: "p",
        text: "现场划分为原画展区、互动装置区与限定周边商店。原画展区将集中展出近百幅设定与分镜，互动装置区则还原了作品中的烟火大会场景。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20an%20outdoor%20night%20festival%20with%20glowing%20paper%20lanterns%20and%20fireworks%20above%20a%20river%2C%20colorful%20stalls%2C%20cel-shaded%2C%20warm%20romantic%20summer%20night%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-06&orientation=landscape",
        caption: "互动装置区还原了作品中的烟火大会场景",
      },
      {
        type: "p",
        text: "限定周边将从展览首日起同步发售，数量有限。具体场次与购票信息请以官方发布为准。",
      },
    ],
    relatedIds: ["n09", "n01"],
  },
  {
    id: "n05",
    title: "《星海列车》获年度最佳剧本奖，主创分享创作幕后",
    summary:
      "在本年度的动画评选活动中，《星海列车》凭借细腻的叙事与完整的人物弧光摘得最佳剧本奖，主创团队分享了创作历程。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20golden%20trophy%20on%20a%20stage%20surrounded%20by%20star%20shaped%20confetti%20and%20warm%20spotlights%2C%20cel-shaded%2C%20elegant%20celebration%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-05&orientation=landscape",
    date: "2025-02-20",
    source: "58动漫编辑部",
    category: "作品资讯",
    content: [
      {
        type: "p",
        text: "在本年度的动画评选活动中，《星海列车》凭借细腻的叙事结构与完整的人物弧光，摘得年度最佳剧本奖。",
      },
      { type: "h", text: "“告别”是核心主题" },
      {
        type: "p",
        text: "主创团队在采访中表示，作品的灵感来源于一次深夜的列车旅行。“我们想讲一个关于告别的故事，但不想让它变得沉重，而是希望每一站都留下一点温暖。”",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20an%20elegant%20award%20ceremony%20hall%20with%20warm%20golden%20stage%20lights%20and%20empty%20stage%2C%20cel-shaded%2C%20formal%20celebration%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-08&orientation=landscape",
        caption: "颁奖现场",
      },
      {
        type: "p",
        text: "谈及后续计划，主创表示希望有机会以特别篇的形式，补充列车在旅途之外的故事。",
      },
    ],
    relatedIds: ["n06", "n01"],
  },
  {
    id: "n06",
    title: "《深海图书馆》与《机械之心》确认联动，特别篇今夏播出",
    summary:
      "两部作品宣布推出联动特别篇，将把水下图书馆与机械少年置于同一世界观下，讲述一段全新的相遇故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20glowing%20underwater%20library%20merging%20with%20a%20mechanical%20giant%20structure%2C%20blue%20and%20amber%20contrast%20lighting%2C%20cel-shaded%2C%20mysterious%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-06&orientation=landscape",
    date: "2025-02-14",
    source: "官方公告",
    category: "作品资讯",
    content: [
      {
        type: "p",
        text: "两部备受关注的作品正式宣布推出联动特别篇。制作方表示，这次的联动并非简单拼盘，而是将两个故事置于同一世界观下重新编织。",
      },
      { type: "h", text: "两个世界的交汇" },
      {
        type: "p",
        text: "特别篇中，深海图书馆的潜水员澪在一次打捞任务里，捞起了沉睡在海底的机械核心。机械少年九号因此苏醒，两个截然不同的世界由此交汇。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20glamorous%20anime%20film%20premiere%20red%20carpet%20with%20spotlights%20and%20decorative%20banners%2C%20warm%20elegant%20tone%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-03&orientation=landscape",
        caption: "联动特别篇公布首支预告",
      },
      {
        type: "p",
        text: "特别篇预计于今年夏季播出，具体档期与播出平台将在后续公布。",
      },
    ],
    relatedIds: ["n05", "n07"],
  },
  {
    id: "n07",
    title: "《赛博忍者》登陆国际流媒体平台，首周播放量破纪录",
    summary:
      "《赛博忍者》上线国际流媒体平台后表现强劲，首周播放量刷新平台同类作品纪录，多地区登上热度榜前列。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20multiple%20screens%20floating%20in%20a%20dark%20room%20showing%20a%20neon%20cyberpunk%20city%2C%20glowing%20interface%20panels%2C%20cel-shaded%2C%20high%20tech%20mood%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-07&orientation=landscape",
    date: "2025-02-08",
    source: "动漫产业周报",
    category: "行业动态",
    content: [
      {
        type: "p",
        text: "《赛博忍者》正式登陆国际流媒体平台后表现强劲，上线首周便刷新了平台同类作品的多项播放纪录。",
      },
      { type: "h", text: "多地区热度登顶" },
      {
        type: "p",
        text: "根据平台公布的数据，该作品在多个国家和地区的热度榜单中名列前茅，其中动作与科幻分类表现尤为突出。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20modern%20living%20room%20at%20night%20with%20a%20large%20glowing%20screen%20showing%20a%20colorful%20anime%20scene%2C%20cozy%20ambient%20light%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-07&orientation=landscape",
        caption: "流媒体平台的观看数据持续攀升",
      },
      {
        type: "p",
        text: "有分析认为，作品紧凑的节奏与国际化的人设，是其在海外市场受到欢迎的重要原因。",
      },
    ],
    relatedIds: ["n10", "n06"],
  },
  {
    id: "n08",
    title: "《天穹纪元》剧场版定档，首支预告片公开",
    summary:
      "官方公布《天穹纪元》剧场版的上映档期，并放出首支预告片。预告展示了全新的天空城邦场景与重要角色的回归。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20colossal%20sky%20citadel%20above%20an%20ocean%20of%20clouds%20at%20sunrise%20with%20flying%20creatures%2C%20epic%20grand%20scale%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-08&orientation=landscape",
    date: "2025-01-30",
    source: "官方公告",
    category: "作品资讯",
    content: [
      {
        type: "p",
        text: "官方正式公布《天穹纪元》剧场版的上映档期，并同步放出首支预告片。预告中展示了全新的天空城邦场景，以及数位重要角色的回归。",
      },
      { type: "h", text: "更宏大的视觉呈现" },
      {
        type: "p",
        text: "从预告来看，剧场版在作画与场景规模上均有明显提升，云海之上的追逐戏份成为最大亮点。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20bright%20anime%20merchandise%20store%20with%20shelves%20of%20figures%2C%20plush%20toys%20and%20posters%2C%20warm%20retail%20lighting%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-04&orientation=landscape",
        caption: "剧场版限定周边信息同步公开",
      },
      {
        type: "p",
        text: "剧场版的具体上映时间与票价信息请以各地发行方公布为准。",
      },
    ],
    relatedIds: ["n03", "n02"],
  },
  {
    id: "n09",
    title: "《樱花剑客录》十周年纪念展将在东京开幕",
    summary:
      "为纪念《樱花剑客录》播出十周年，官方将举办大型纪念展，展出原画、道具与未公开设定，并设置沉浸式体验区。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20traditional%20japanese%20exhibition%20hall%20with%20display%20cases%20of%20scrolls%20and%20swords%2C%20cherry%20blossom%20decorations%2C%20warm%20lantern%20lighting%2C%20cel-shaded%2C%20elegant%20serene%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-09&orientation=landscape",
    date: "2025-01-22",
    source: "展会组委会",
    category: "展会信息",
    content: [
      {
        type: "p",
        text: "为纪念《樱花剑客录》播出十周年，官方将举办大型纪念展，展出作品十年来的珍贵资料与创作手稿。",
      },
      { type: "h", text: "未公开设定首次展出" },
      {
        type: "p",
        text: "展览将首次公开大量未使用的角色设定与场景分镜，并设置沉浸式体验区，还原作品中的樱丘桥场景。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20lively%20anime%20convention%20hall%20with%20cosplayers%20and%20booths%20under%20warm%20lights%2C%20crowd%20of%20fans%2C%20cel-shaded%2C%20cheerful%20festive%20mood%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-01&orientation=landscape",
        caption: "纪念展现场将设置多个主题区域",
      },
      {
        type: "p",
        text: "展览期间还将举办主创对谈活动，具体参与方式以官方公告为准。",
      },
    ],
    relatedIds: ["n04", "n01"],
  },
  {
    id: "n10",
    title: "年度动画产业论坛召开，聚焦原创内容与新技术应用",
    summary:
      "本年度动画产业论坛近日举行，来自制作、发行与平台各方的从业者围绕原创内容扶持与技术应用展开讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20editorial%20illustration%20of%20a%20modern%20conference%20hall%20with%20a%20large%20stage%20screen%20and%20seated%20audience%2C%20warm%20professional%20lighting%2C%20cel-shaded%2C%20clean%20simple%20background%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=news-cover-10&orientation=landscape",
    date: "2025-01-15",
    source: "动漫产业周报",
    category: "行业动态",
    content: [
      {
        type: "p",
        text: "本年度动画产业论坛近日举行，来自制作、发行与流媒体平台各方的从业者齐聚一堂，围绕行业趋势展开讨论。",
      },
      { type: "h", text: "原创内容与新技术的平衡" },
      {
        type: "p",
        text: "与会者普遍认为，新技术的引入能够提升制作效率，但作品的核心竞争力仍然在于原创内容与情感表达。",
      },
      {
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Anime%20style%20wide%20illustration%20of%20a%20modern%20press%20conference%20stage%20with%20large%20screens%20and%20warm%20spotlights%2C%20simple%20clean%20hall%2C%20cel-shaded%2C%20professional%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1200&height=675&seq=news-inline-05&orientation=landscape",
        caption: "论坛现场围绕原创内容展开讨论",
      },
      {
        type: "p",
        text: "论坛还发布了年度产业观察报告，对未来的内容趋势与市场结构进行了展望。",
      },
    ],
    relatedIds: ["n07", "n02"],
  },
];